function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { LengthInput } from "../../primitives/LengthInput";
import { CSSEnum } from "./enum-helpers";
import { getEnumOptions } from "./helpers";
export const CSSStringEditor = (props)=>{
    const { // Influences the color
    value, onChangeValue, baseType } = props;
    // We'll try to use the enum hint to render a dropdown or
    // a set of buttons
    const enumOptions = getEnumOptions(value, baseType);
    if (enumOptions) {
        const originalValue = value;
        return /*#__PURE__*/ _jsx(CSSEnum, {
            props: _object_spread({}, props),
            onSelectOption: (value)=>{
                console.log(`CSSEnum - onSelectOption`, value);
                onChangeValue && onChangeValue(_object_spread_props(_object_spread({}, originalValue), {
                    type: "css-string",
                    value
                }));
            },
            enumOptions: enumOptions
        });
    }
    return /*#__PURE__*/ _jsx(LengthInput, {
        readOnly: !!props.readOnly,
        value: (value === null || value === void 0 ? void 0 : value.value) || "",
        onChange: (e)=>{
            onChangeValue && onChangeValue({
                type: "css-string",
                value: e.target.value || "",
                cssEnumHint: (value === null || value === void 0 ? void 0 : value.cssEnumHint) || undefined
            });
        }
    });
};
